import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { ErrorMessage as HookformErrorMessage } from "@hookform/error-message";

const useStyles = makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
  },
}));

const ErrorMessage = ({ name, errors }) => {
  const classes = useStyles();

  return (
    <HookformErrorMessage
      errors={errors}
      name={name}
      render={({ message }) => <span className={classes.error}>{message}</span>}
    />
  );
};

ErrorMessage.propTypes = {
  name: PropTypes.string.isRequired,
  errors: PropTypes.object
};

export default ErrorMessage;
